import { Schema } from "effect";
import { TextConciergeFilterTab } from "../models/shopper-ai/conversation/text-concierge";

export const StartShopperAgentExportInput = Schema.Struct({
  /** Reply-status tab active at click-time. Omitted means `all`. */
  filterTab: Schema.optional(TextConciergeFilterTab),
});
export type StartShopperAgentExportInput =
  typeof StartShopperAgentExportInput.Type;

export const StartShopperAgentExportResponse = Schema.Struct({
  workflowId: Schema.String,
  /**
   * Presigned download URL, present only when the export finished within the
   * handler's 30s inline wait. Absent means the file arrives via email.
   */
  fileUrl: Schema.optional(Schema.String),
});
export type StartShopperAgentExportResponse =
  typeof StartShopperAgentExportResponse.Type;
